import VideoJsAdapter from '../../adapters/videojs_adapter';
import Component from "../component";

export default class Index extends Component {
  constructor(player, options = {}){
    super(player, options);
  }

  ready(){
    this.player().one('playing', this.onFirstPlay.bind(this));
    this.player().on('ended', this.onEnded.bind(this));
  }

  createEl(){
    let el = super.createEl('div', {
     className: 'vjs-top-bar'
    });

    el.innerHTML = `
      ${this.imageElement()}
      ${this.titleElement()}
    `;
    return el;
  }

  onFirstPlay(){
    if(this.userIsInactive()){
      this.hide();
    }
    this.registerUserInteraction();
  }

  registerUserInteraction(){
    this.player().on('userinactive', this.onUserInactive.bind(this));
    this.player().on('useractive', this.onUserActive.bind(this));
  }

  onEnded(){
    this._ended = true;
    this.show();

    this.player().one('playing', this.onContentRePlaying.bind(this));
  }

  onContentRePlaying(){
    this._ended = false;
  }

  onUserInactive(){
    if(this.playerIsPaused() || this._ended) return;

    this.hide();
  }

  onUserActive(){
    if(this.playerIsPaused() || this._ended) return;

    this.show();
  }

  hide(){
    this.el().classList.add('vjs-top-bar--hidden');
  }

  show(){
    this.el().classList.remove('vjs-top-bar--hidden');
  }

  userIsInactive(){
    this.player().el().classList.contains('vjs-user-inactive');
  }

  playerIsPaused(){
    return this.player().paused();
  }

  imageElement(){
    return `
      <a class="vjs-top-bar__avatar-container" href="${this.userProfileUrl()}" target="_parent">
        <img src="${this.userAvatarUrl()}" alt="Content owner avatar" />
      </a>
    `;
  }

  userProfileUrl(){
    return `${this.options().userProfileUrl}?utm_source=embed&utm_medium=UploaderPicture`;
  }

  watchpageUrl(){
    return `${this.options().watchpageUrl}?utm_source=embed&utm_medium=ContentTitle`;
  }

  userAvatarUrl(){
    return this.options().userAvatarUrl;
  }

  title(){
    return this.options().title;
  }

  titleElement(){
    return `
      <a class="vjs-top-bar__title-container" href="${this.watchpageUrl()}" target="_parent">
        <h1 class="vjs-top-bar__title">${this.title()}</h1>
      </a>
    `;
  }
}

VideoJsAdapter.registerComponent('VpTopBar', Index);
